// extracted by mini-css-extract-plugin
export default {"main":"AlumnoSelector_main__4TlR3"};